import { useRef, useEffect } from "react";
import { Bold, Italic, Heading2, List, ListOrdered, Link2, Undo2 } from "lucide-react";

export default function RichTextEditor({ value, onChange, testid = "rich-editor" }) {
  const ref = useRef(null);

  useEffect(() => {
    const el = ref.current;
    if (el && document.activeElement !== el && el.innerHTML !== (value || "")) {
      el.innerHTML = value || "";
    }
  }, [value]);

  const exec = (cmd, arg = null) => {
    document.execCommand(cmd, false, arg);
    ref.current?.focus();
    onChange(ref.current.innerHTML);
  };

  const addLink = () => {
    const url = window.prompt("Bağlantı adresi (URL):", "https://");
    if (url) exec("createLink", url);
  };

  const Btn = ({ onClick, icon: Icon, label }) => (
    <button
      type="button"
      onClick={onClick}
      title={label}
      className="grid place-items-center h-9 w-9 rounded-lg text-[#0F2F1D] hover:bg-[#1B4D2E]/10 transition-colors"
    >
      <Icon className="h-4 w-4" />
    </button>
  );

  return (
    <div className="rounded-2xl border border-[#E2E8E4] bg-white overflow-hidden">
      <div className="flex items-center gap-1 border-b border-[#E2E8E4] px-2 py-1.5 bg-[#F8F9FA]">
        <Btn onClick={() => exec("bold")} icon={Bold} label="Kalın" />
        <Btn onClick={() => exec("italic")} icon={Italic} label="İtalik" />
        <Btn onClick={() => exec("formatBlock", "<h2>")} icon={Heading2} label="Başlık" />
        <Btn onClick={() => exec("insertUnorderedList")} icon={List} label="Liste" />
        <Btn onClick={() => exec("insertOrderedList")} icon={ListOrdered} label="Numaralı Liste" />
        <Btn onClick={addLink} icon={Link2} label="Bağlantı" />
        <Btn onClick={() => exec("undo")} icon={Undo2} label="Geri Al" />
      </div>
      <div
        ref={ref}
        data-testid={testid}
        contentEditable
        suppressContentEditableWarning
        onInput={(e) => onChange(e.currentTarget.innerHTML)}
        className="rich-content min-h-[220px] max-h-[420px] overflow-y-auto px-5 py-4 focus:outline-none text-[#37473d]"
      />
    </div>
  );
}
